import { useMutation, useQueryClient } from "@tanstack/react-query";
import createScheduledReport from "api/scheduledReports/createScheduledReport";
import handleInvalidateError from "helpers/handleInvalidateError";
import { scheduledReportsKey } from "queryKeys/scheduledReportsKey";
import { toast } from "react-toastify";

export default function useCreateScheduledReportMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createScheduledReport,
    onSuccess: (data) => {
      toast.success(data.message || "Scheduled report created successfully.");

      queryClient
        .invalidateQueries({ queryKey: scheduledReportsKey() })
        .catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
